import { HEALTH_STATUS } from '@/types/enums/health-status.enum';
import { ASSETS_HEALTH_STATUS_ITEMS } from './filter-options';
import { ASSETS_HEALTH_STATUS_ID } from './types/filter.enums';
import {
  FILTER_OPTIONS_TYPE,
  FILTER_PLACEMENT,
  FILTER_TYPE,
  FILTER_TRIGGER_TYPE,
  FilterConfig,
  FilterOption,
} from '@/components/uiKit/FiltersGroup/types';
import { Fault } from '@/types/models/faults.types';

// Fault Status Filter
export enum FAULT_STATUS_ID {
  WO_ASSIGNED = 'wo-assigned',
  WO_NOT_ASSIGNED = 'wo-not-assigned',
}

export enum FAULT_STATUS_LABEL {
  WO_ASSIGNED = 'WO Assigned',
  WO_NOT_ASSIGNED = 'WO not Assigned',
}

export const FAULT_STATUS_ITEMS: FilterOption[] = [
  {
    id: FAULT_STATUS_ID.WO_ASSIGNED,
    label: FAULT_STATUS_LABEL.WO_ASSIGNED,
  },
  {
    id: FAULT_STATUS_ID.WO_NOT_ASSIGNED,
    label: FAULT_STATUS_LABEL.WO_NOT_ASSIGNED,
  },
];

// Filter Labels for Faults
export enum FAULTS_FILTER_LABEL {
  SEVERITY = 'Severity',
  FAULT_STATUS = 'Fault Status',
  ASSET_TYPE = 'Asset Type',
  ASSET_AREA = 'Asset Area',
}

export const faultsFilterConfig: FilterConfig = [
  // Severity (health_status) - direct field
  {
    allStaticValues: ASSETS_HEALTH_STATUS_ITEMS.map((item) => item.id),
    initialStaticValues: ASSETS_HEALTH_STATUS_ITEMS.map((item) => item.id),
    fieldName: 'health_status',
    fieldValueToFilterValueMapping: (fieldValue: string) => {
      if (fieldValue === HEALTH_STATUS.CRITICAL) return ASSETS_HEALTH_STATUS_ID.CRITICAL;
      if (fieldValue === HEALTH_STATUS.ALARM) return ASSETS_HEALTH_STATUS_ID.ALARM;
      if (fieldValue === HEALTH_STATUS.MONITOR) return ASSETS_HEALTH_STATUS_ID.MONITOR;
      if (fieldValue === HEALTH_STATUS.HEALTHY) return ASSETS_HEALTH_STATUS_ID.HEALTHY;
      return ASSETS_HEALTH_STATUS_ID.NA;
    },
    filterOptionsType: FILTER_OPTIONS_TYPE.STATIC,
    filterData: {
      filterLabel: FAULTS_FILTER_LABEL.SEVERITY,
      placement: FILTER_PLACEMENT.QUICK,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.BUTTON,
      triggerProps: {
        variant: 'outline',
        size: 'default',
      },
      filterOptions: ASSETS_HEALTH_STATUS_ITEMS,
    },
  },
  // Fault Status (based on work_orders array)
  {
    allStaticValues: FAULT_STATUS_ITEMS.map((item) => item.id),
    initialStaticValues: FAULT_STATUS_ITEMS.map((item) => item.id),
    fieldName: 'work_orders',
    fieldValueToFilterValueMapping: (fieldValue: any[]) =>
      fieldValue && fieldValue.length > 0 ? FAULT_STATUS_ID.WO_ASSIGNED : FAULT_STATUS_ID.WO_NOT_ASSIGNED,
    filterOptionsType: FILTER_OPTIONS_TYPE.STATIC,
    filterData: {
      filterLabel: FAULTS_FILTER_LABEL.FAULT_STATUS,
      placement: FILTER_PLACEMENT.QUICK,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.BUTTON,
      triggerProps: {
        variant: 'outline',
        size: 'default',
      },
      filterOptions: FAULT_STATUS_ITEMS,
    },
  },
  // Asset Type - nested in location.asset_type
  {
    allStaticValues: [],
    initialStaticValues: [],
    fieldName: 'location.asset_type',
    fieldAccessor: (item: Fault) => item.location?.asset_type,
    fieldValueToFilterValueMapping: (fieldValue: string) => fieldValue,
    filterOptionsType: FILTER_OPTIONS_TYPE.DYNAMIC,
    filterData: {
      filterLabel: FAULTS_FILTER_LABEL.ASSET_TYPE,
      placement: FILTER_PLACEMENT.QUICK,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.BUTTON,
      triggerProps: {
        variant: 'outline',
        size: 'default',
      },
      filterOptions: [],
    },
  },
  // Asset Area - nested in location.asset_area
  {
    allStaticValues: [],
    initialStaticValues: [],
    fieldName: 'location.asset_area',
    fieldAccessor: (item: Fault) => item.location?.asset_area,
    fieldValueToFilterValueMapping: (fieldValue: string) => fieldValue,
    filterOptionsType: FILTER_OPTIONS_TYPE.DYNAMIC,
    filterData: {
      filterLabel: FAULTS_FILTER_LABEL.ASSET_AREA,
      placement: FILTER_PLACEMENT.QUICK,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.BUTTON,
      triggerProps: {
        variant: 'outline',
        size: 'default',
      },
      filterOptions: [],
    },
  },
];
